import { render, staticRenderFns } from "./_productView.vue?vue&type=template&id=1d60cb9c"
import script from "./_productView.vue?vue&type=script&lang=js"
export * from "./_productView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports